import axios from "axios";
import Swal from "sweetalert2";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    serverUrl: "https://api-thaiairways.zwiz.app/",
    query: {},
    profile: {},
    member: {},
    locale: "th",
    userid: "",
    receivePromotionStatus: "",
    consentSensitiveStatus: "",
    checkboxConsentPDPA: "",
  },
  mutations: {},
  actions: {
    async getMemberByUserId({ state }) {
      let vm = this;
      let userid = state.userid;
      await axios
        .get(`${state.serverUrl}v1/member/getByUserid/${userid}`, {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        })
        .then(async (response) => {
          if (response && response.data.responsecode == 200) {
            let responseMember = response.data.data[0];
            if (responseMember && responseMember.memberid) {
              state.member = responseMember;

              if (state.query.view == "Register") {
                state.query.view = "Profile";
              }
            } else {
              state.query.view = "PrivacyNotice";
            }
          }
        });
    },
    sendMessage({ state }, message) {
      var vm = this;
      return new Promise(async (resolve) => {
        var url = `${state.serverUrl}zwiz-pushmsg-webbrowser`;
        var data = {
          pageid: state.query.pageid,
          userid: state.userid,
          message,
        };
        if (await window.liff.isInClient()) {
          try {
            await window.liff.sendMessages([
              {
                text: message,
                type: "text",
              },
            ]);
            resolve();
          } catch (error) {
            alert(JSON.stringify(error));
            alert(JSON.stringify(error.message));
          }
        } else {
          axios
            .post(url, data, {
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            })
            .then(async (response) => {
              if (response.data.responsecode == 200) {
                resolve();
              } else {
                if (response.data.reason) {
                  await Swal.fire({
                    text: response.data.reason,
                  });
                  resolve();
                }
              }
            });
        }
      });
    },
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() {},
        function error() {
          window.close();
        }
      );
    },
  },
  modules: {},
});
